import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function M1Icon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 30 30"
      viewBox="0 0 30 30"
      titleAccess="M1">
      <path
        d="M.8 10.4c0-1.7 0-2.5.3-3.2.3-.6.7-1 1.3-1.3.7-.3 1.6-.3 3.2-.3h18.7c1.7 0 2.5 0 3.2.3.6.3 1 .7 1.3 1.3.3.6.3 1.5.3 3.2v10.2c0 1.7 0 2.5-.3 3.2-.3.6-.7 1-1.3 1.3-.6.3-1.5.3-3.2.3H5.6c-1.7 0-2.5 0-3.2-.3-.6-.3-1-.7-1.3-1.3-.3-.6-.3-1.5-.3-3.2V10.4z"
        fill="#0a4842"
      />
      <path
        d="M.8 10.4c0-1.7 0-2.5.3-3.2.3-.6.7-1 1.3-1.3.7-.3 1.6-.3 3.2-.3h18.7c1.7 0 2.5 0 3.2.3.6.3 1 .7 1.3 1.3.3.6.3 1.5.3 3.2v10.2c0 1.7 0 2.5-.3 3.2-.3.6-.7 1-1.3 1.3-.6.3-1.5.3-3.2.3H5.6c-1.7 0-2.5 0-3.2-.3-.6-.3-1-.7-1.3-1.3-.3-.6-.3-1.5-.3-3.2V10.4z"
        fill="none"
        stroke="#f2b460"
        strokeWidth={1.5}
      />
      <path
        d="M8.8 19.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-6.2c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h.6c.2 0 .3 0 .5.1.1.1.2.2.3.4l1.5 3.8 1.6-3.8c.1-.2.2-.3.3-.4.1-.1.3-.1.5-.1h.6c.2 0 .3.1.4.2.1.1.2.2.2.4V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.5c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-3.9l-1 2.3c-.1.2-.2.3-.3.4-.1.1-.3.1-.5.1h-.3c-.2 0-.3 0-.5-.1-.1-.1-.2-.2-.3-.4l-1-2.3V19c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.3zm8.6-4.4c-.1.1-.2.1-.3 0-.1 0-.1-.1-.1-.2v-.7c0-.4.2-.7.5-.9l1-.7c.3-.2.6-.3 1-.3h.6c.2 0 .3.1.4.2.1.1.2.2.2.4v6c0 .2-.1.3-.2.4-.1.1-.2.2-.4.2h-.6c-.2 0-.3-.1-.4-.2-.1-.1-.2-.2-.2-.4v-4.9l-1.5 1.1z"
        fill="#f2b460"
      />
    </SvgIcon>
  );
}
